import qs from 'qs'; 

const ProgramList = {
    namespaced: true,

    state: {
        programListData: [],
    },

    getters: {
        programListData (state) {
            return state.programListData;
        },
    },

    mutations: {

        /**
         * Установить значение programList
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['programListData'] = items;
        },

        /**
         * Обновить значение элемента programList
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['programListData'][index] = item;
        },

        /**
         * Добавить значение элемента programList
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['programListData'].push(item);
        },

        /**
         * Удалить элемент из programList
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['programListData'] = state['programListData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по programList
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getProgramListData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.programList,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам программ получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN programList.js | getProgramListData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по шаблонам программ!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по programList
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveProgramListData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.programList,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам программ успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.programListId = response.data[0].programListId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый шаблон программ успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN programList.js | saveProgramListData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление записи из programList
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeProgramListData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.programList,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Шаблон программ успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении шаблона программ!'),
                    console.log('ERROR IN programList.js | removeProgramListData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default ProgramList;





// WEBPACK FOOTER //
// ./src/store/modules/programList.js